import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import Cookies from "js-cookie";
// import store from '@/store'
// import { getToken } from '@/utils/auth'
import errorCode from '@/util/errorCode'
// import Router from '@/router'

// axios.defaults.headers['Content-Type'] = 'application/json'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: 'https://schoolmedia.hebyun.com.cn',
  // 超时
  timeout: 10000
})
// function stringify (data) {
//   const formData = new FormData()
//   for (const key in data) {
//     // eslint-disable-next-line no-prototype-builtins
//     if (data.hasOwnProperty(key)) {
//       if (data[key]) {
//         if (data[key].constructor === Array) {
//           if (data[key][0]) {
//             if (data[key][0].constructor === Object) {
//               formData.append(key, JSON.stringify(data[key]))
//             } else {
//               data[key].forEach((item, index) => {
//                 formData.append(key + `[${index}]`, item)
//               })
//             }
//           } else {
//             formData.append(key + '[]', '')
//           }
//         } else if (data[key].constructor === Object) {
//           formData.append(key, JSON.stringify(data[key]))
//         } else {
//           formData.append(key, data[key])
//         }
//       } else {
//         if (data[key] === 0) {
//           formData.append(key, 0)
//         } else {
//           formData.append(key, '')
//         }
//       }
//     }
//   }
//   return formData
// }
// service.defaults.transformRequest = (data) => {
//   return stringify(data)
// }
// // request拦截器
// service.interceptors.request.use(config => {
//   // 是否需要设置 token
//  //  if (Cookies.get('token')) {
//  //  	// req.setRequestHeader("token", getCookie('token'));
//  //  	// req.setRequestHeader("key", getCookie('key'));
// 	// config.headers['key'] = Cookies.get("key")
// 	// config.headers['token'] = Cookies.get("token")
  	
//  //  }
  
  
//   return config
// }, error => {
//     console.log(error)
//     Promise.reject(error)
// })

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.status || 200;
    // 获取错误信息
    // const msg = errorCode[code] || res.data.msg || errorCode['default']
    return res.data
	// return res.data
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    // else if (message.includes("Request failed with status code")) {
    //   message = "系统接口" + message.substr(message.length - 3) + "异常";
    // }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
